import React from 'react';
import Layout from '../../../Layout/StandardLayout';
import SecondaryPanel from '../../../Layout/SecondaryPanel';

const FeatureSuggestion = () => {
  return (
    <Layout
      title="Feature Suggestion"
      description="A critical piece of Clientbook is getting user feedback. Use the section below to submit your own ideas or vote on ideas by other retailers."
      breadcrumb="Help >> Feature Suggestions"
      breadCrumbs={[{ title: 'Help' }, { title: 'Feature Suggestion' }]}
      classProps="standard-width-with-sidebar"
    >
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfOTVG7w6IxEbcnps9eff0FcQ8tQsvn1043Nc15AWIkHCMHTQ/viewform?embedded=true"
        width="640"
        height="972"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      >
        Loading…
      </iframe>
    </Layout>
  );
};
export default FeatureSuggestion;
